import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

export const StyledTabContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  flex-flow: nowrap;

  & > :first-child {
    margin-top: 4px;
  }
`;

export const StyledTabHeader = styled.button<{
  width?: string;
  isCurrentTab: boolean;
}>`
  width: ${({ width = "max-content" }) => `${width}px`};
  min-width: 100px;
  height: 30px;

  padding: 0px 4px;

  align-items: center;
  justify-content: center;

  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
  color: ${({ isCurrentTab = false }) =>
    isCurrentTab
      ? DIGIPOSTHEME.colors.white
      : DIGIPOSTHEME.colors.secondaryAkbankBlack};

  background-color: ${({ isCurrentTab = false }) =>
    isCurrentTab
      ? DIGIPOSTHEME.colors.headerRed
      : DIGIPOSTHEME.colors.footerGrey};

  outline: none;

  background-position: center;
  transition: background 0.6s;
  border: none;
  border-left: 1px solid white;
  border-right: 1px solid white;
  border-radius: 5px;
  border-bottom: 2px solid ${DIGIPOSTHEME.colors.white};

  ${({ isCurrentTab = false }) =>
    isCurrentTab &&
    `transform: scale(1.04);transform: translate(0px,-3px);border-bottom: 1px solid ${DIGIPOSTHEME.colors.headerRed}; box-shadow: rgb(0 0 0 / 20%) 0px 9px 8px 4px;`};

  :hover {
    background: ${DIGIPOSTHEME.colors.cherryRed}
      radial-gradient(
        circle,
        transparent 1%,
        ${DIGIPOSTHEME.colors.headerRed} 1%
      )
      center/15000%;
  }

  :active {
    background-color: ${DIGIPOSTHEME.colors.headerRed};
    background-size: 100%;
    transition: background 0s;
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    height: 35px;
  }
`;

export const StyledOuterContainer = styled.div`
  width: max-content;

  display: flex;
  position: relative;
  align-items: center;
`;

export const StyledVerticalLine = styled.span<{ width: string; left: string }>`
  width: ${({ width = "0" }) => `${width}px`};
  left: ${({ left = "100px" }) => `${left}px`};

  position: absolute;
  display: block;

  bottom: 0px;

  transition-duration: 300ms;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  background-color: ${DIGIPOSTHEME.colors.secondaryGraySecondary};

  height: 2px;
`;

export const StyledTabItemContainer = styled.div`
  width: 100%;
`;

export const StyledTabInfo = styled.div`
  width: auto;

  display: flex;
  justify-content: space-between;
  align-items: center;

  border-bottom: 2px solid ${DIGIPOSTHEME.colors.cherryRed};

  font-family: "Campton";
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.23px;
  line-height: 1.33;
  color: ${DIGIPOSTHEME.colors.secondaryAkbankBlack};

  @media ${MEDIA_QUERIES.MOBILE} {
    padding: 0 20px 5px;
    font-size: 14px;
  }
`;
